import { createContext, useEffect, useState } from 'react';
import authService from '../../components/api-authorization/AuthorizeService';
import { getLoggedInUser } from './user.api';
import axios from 'axios';

export interface IUser {
	id: number;
	institutionId: number;
	name: string;
	roles: string[];
	email: string;
	isEpiqUser: boolean;
	isOffshoreUser: boolean;
	countryCode: number;
}

export type UserContextType = {
	user: IUser;
	isAuthenticated: boolean;
	isInRole: Function;
	isInitialized: boolean;
}

export const UserContext = createContext<UserContextType | null>(null);

const getInitialUser = () => {
	return {
		id: 0,
		institutionId: 0,
		name: '',
		roles: [],
		email: '',
		isEpiqUser: false,
		isOffshoreUser: false,
		countryCode: 0
	} as IUser;
}

const UserProvider = ({ children }: any) => {
	let [user, setUser] = useState<IUser>(getInitialUser());

	let [isInitialized, setIsInitialized] = useState(false);
	let [isAuthenticated, setIsAuthenticated] = useState(false);

	useEffect(() => {
		let subscription = authService.subscribe(async () => await populateState());

		const initializeState = async () => {
			await populateState();
		};

		initializeState();

		return () => {
			authService.unsubscribe(subscription);
		};
	});

	useEffect(() => {
		let populateUserAsync = async () => {
			if (!isAuthenticated) {
				setUser(getInitialUser());
				return;
			}

			const loggedInUser = await getLoggedInUser();

			if (loggedInUser) {
				setUser(loggedInUser);
			}
		}

		try {
			populateUserAsync();

		}
		catch (error) {
			console.error('Error:', error);
		}

	}, [isAuthenticated]);

	const isInRole = (roles: string[]): boolean => {
		let userRoles = user?.roles?.map(i => i.toUpperCase())

		if (userRoles && userRoles.length > 0) {
			for (let i = 0; i < roles.length; i++) {
				if (userRoles.includes(roles[i].toUpperCase())) {
					return true;
				}
			}
		}

		return false;
	}

	const populateState = async () => {
		try {
			if (await authService.isAuthenticated()) {
				setIsAuthenticated(true);
			}

			setIsInitialized(true);
		}

		catch (error) {
			console.error('Error:', error);
		}
	}

	return (
		<UserContext.Provider value={{ user, isAuthenticated, isInRole, isInitialized }}>
			{children}
		</UserContext.Provider>
	);
}

export default UserProvider;